import {FC, useEffect, useState, useRef} from 'react'
import plusIcon from '../../../../_metronic/images/smlplus.svg'
import {CreateQcModal} from './CreateQcModal'
import {useLazyQuery, useMutation} from '@apollo/client'
import {QC_USER_LIST, REMOVE_QC_USER} from '../../../../utils/GraphQLAPI'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import DateRangePickers from '../../../sharedComponent/DateRangePickers/DateRangePickers'
import moment from 'moment'
import DownloadCsv from '../../Download/DownloadCsv'

import Breadcrumbs from '../../../sharedComponent/Breadcrumbs/Breadcrumbs'
import SearchList from '../../../sharedComponent/SearchList/SearchList'
import {QCUSERLISTCONFIGS} from '../../../../utils/TeamAdmin/QcUserUtils'
import {dropdownMenuItemsType} from '../../../sharedComponent/SearchList/SearchList.types'
import {areYouSurePrompt} from '../../../../utils/helper'

const MySwal = withReactContent(Swal)

const QcUserList: FC = () => {
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [createModal, setCreateModal] = useState<string>('create')
  const [qcid, setQcId] = useState<any>()
  const [csv, setCsv] = useState<boolean>(false)
  const [downloadData, setDownloadData] = useState<any>([])
  const [filterTempOptions, setFilterTempOptions] = useState<any>()
  const csvRef = useRef<any>(null)

  const [filterOptions, setFilterOptions] = useState<any>({
    searchText: '',
    page: 1,
    perPage: 10,
    fromDate: new Date(
      moment(moment().subtract(29, 'days').toDate()).format('YYYY-MM-DD') + 'T00:00:00'
    ).toISOString(),
    toDate: new Date(moment(moment().toDate()).format('YYYY-MM-DD') + 'T23:59:00').toISOString(),
  })
  const openModal = (editId: any) => {
    setShowCreateAppModal(true)
    if (editId) {
      setCreateModal('edit')
      setQcId(editId)
    } else {
      setCreateModal('create')
      setQcId('')
    }
  }

  const handleCloseModal = () => {
    refetch()
    setShowCreateAppModal(false)
    setQcId('')
  }

  const refreshQcUserList = () => {
    refetch()
  }

  // List API
  const [getQcListByTeamAdmin, {loading: qcuserListLoading, refetch, data: qcuserList}] =
    useLazyQuery(QC_USER_LIST, {
      fetchPolicy: 'network-only',
      onError: (err) => console.log('error', err),
    })

  const getdataFromDateFilter = (fromDate: any, toDate: any, objDays: any) => {
    console.log('objDays', objDays)
    setFilterOptions((prevOptions: any) => {
      return {...prevOptions, fromDate, toDate}
    })
  }

  useEffect(() => {
    getQcListByTeamAdmin({
      variables: {
        qcListInput: filterOptions,
      },
    })
  }, [filterOptions])

  // QC List Download API  Hit
  const [getQcCSVListByTeamAdmin, {loading: reload}] = useLazyQuery(QC_USER_LIST, {
    fetchPolicy: 'network-only',
    variables: {
      qcListInput: filterTempOptions,
    },
    onCompleted: (data) => {
      setDownloadData(
        data.getQcListByTeamAdmin.qcAdmins.map(
          (item: {qcSignInTime: moment.MomentInput; qcSignOutTime: moment.MomentInput}) => ({
            ...item,
            qcSignInTime:
              item.qcSignInTime != null
                ? moment.utc(item.qcSignInTime).local().format('ll, hh:mm A')
                : '-',
            qcSignOutTime:
              item.qcSignOutTime != null
                ? moment.utc(item.qcSignOutTime).local().format('ll, hh:mm A')
                : '-',
          })
        )
      )
    },
    onError: (err) => console.log('error', err),
  })
  const [deleteqcuser] = useMutation(REMOVE_QC_USER, {
    onCompleted: () => {
      MySwal.fire({
        title: 'Deleted!',
        text: 'Your data has been deleted.',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      })
      refetch()
    },
  })

  useEffect(() => {
    const {page, perPage, ...rest} = filterOptions
    setFilterTempOptions(rest)
  }, [filterOptions])

  //QC List Download
  const csvHeaders = [
    {label: 'QC Full Name', key: 'qcName'},
    {label: 'QC Email ID', key: 'emailId'},
    {label: '#Sales Channels', key: 'noOfSalesChannel'},
    {label: 'Successful TPVS', key: 'noOfAcceptedTpvs'},
    {label: 'Pending TPVS', key: 'noOfPendingTpvs'},
    {label: 'Sign In', key: 'qcSignInTime'},
    {label: 'Out Time', key: 'qcSignOutTime'},
  ]
  const csvDownloadFun = async () => {
    await getQcCSVListByTeamAdmin()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  const removeQcUser = (id: any) => {
    areYouSurePrompt(
      'Are you sure?',
      () => {
        deleteqcuser({
          variables: {
            qcUserids: id,
          },
        })
      },
      () => {},
      'Yes, delete it',
      'No, cancel !'
    )
  }
  const dropdownMenuItems: dropdownMenuItemsType[] = [
    {
      name: 'Edit',
      callBack: openModal,
    },
    {
      name: 'Delete',
      callBack: removeQcUser,
      textColor: 'text-danger',
    },
  ]

  return (
    <>
      <Breadcrumbs title='QC Users List' subTitle='Home - QC Users' />
      <SearchList
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        listConfigs={QCUSERLISTCONFIGS}
        listCount={qcuserList?.getQcListByTeamAdmin?.totalCount}
        paginatedCount={qcuserList?.getQcListByTeamAdmin?.qcAdmins?.length}
        listLoading={qcuserListLoading}
        apiData={qcuserList?.getQcListByTeamAdmin.qcAdmins}
        idFieldName='id'
        isActiveApiFieldName=''
        toolbar={
          <>
            <div className='m-0'>
              {qcuserList?.getQcListByTeamAdmin?.totalCount !== 0 && (
                <DownloadCsv
                  csvDownloadFun={csvDownloadFun}
                  reload={reload}
                  csvHeaders={csvHeaders}
                  csvRef={csvRef}
                  downloadData={downloadData}
                  downloadFileName='QCUser.csv'
                />
              )}
            </div>
            <div className='m-0 qc-list-date-filter'>
              <DateRangePickers getdataFromDateFilter={getdataFromDateFilter} />
            </div>
            <div className='m-0'>
              <button
                className='btn btn-primary fs-6 p-3 w-142px h-43px'
                onClick={(e) => openModal('')}
                type='button'
              >
                <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                <span>Add QC User</span>
              </button>
            </div>
            {
              <CreateQcModal
                show={showCreateAppModal}
                handleClose={handleCloseModal}
                refetchList={refreshQcUserList}
                method={createModal}
                editId={qcid}
              />
            }
          </>
        }
        dropdownMenuItems={dropdownMenuItems}
      />
    </>
  )
}

export default QcUserList
